import { AutocompleteContentDirective } from './autocomplete-content.directive';
import { AutocompleteComponent } from './autocomplete.component';
import { AutocompleteDirective } from './autocomplete.directive';
import { OptionComponent } from './option.component';

export * from './autocomplete-content.directive';
export * from './autocomplete.component';
export * from './autocomplete.directive';
export * from './option.component';

export const AutocompleModule = [
  AutocompleteComponent,
  AutocompleteDirective,
  AutocompleteContentDirective,
  OptionComponent,
];
